<div
    class="!z-[950] h-[53px] border-t border-p-content-border-color bp908:border-t-0 bp908:h-full w-full flex flex-row bp908:flex-col items-center justify-between bp908:px-3 px-4 bp908:pt-4 bp908:pb-6 bp908:bg-primary bg-p-content-background touch-none">
    <!-- Desktop - Navbar on the left -->
    @if (!viewportService.isMobile()) {
        <div class="hidden bp908:flex flex-col items-center justify-center">
            <fm-logo-link class="hidden bp908:flex flex w-8 h-8" />
        </div>

        <div class="hidden bp908:flex flex-col items-center justify-end gap-3">
            <fm-home-link class="flex w-8 h-8" />
            <fm-people-link class="flex w-8 h-8" pTooltip="People" tooltipPosition="right" />
            <fm-refer-link [emphasizeAnimation]="emphasizeReferIcon" class="flex w-8 h-8" />
            <fm-settings-link class="flex w-8 h-8" />
            <fm-help-link class="flex w-8 h-8" />
            @if (isFmAdmin || isGroupAdmin) {
                <fm-groups-link class="flex w-8 h-8" />
            }
            @if (isFmAdmin) {
                <fm-admin-link [gender]="gender" class="flex w-8 h-8" />
            }
            <fm-profile-link class="flex w-8 h-8" />
        </div>
    } @else {
        <!-- Modile -->
        <div class="flex flex-row items-center justify-around w-full gap-1 !z-[950]">
            <fm-home-link class="flex flex-1 h-9 !z-[950]" />
            <fm-schedule-link class="flex flex-1 h-9 !z-[950]" />
            <fm-favorites-link class="flex flex-1 h-9 !z-[950]" />
            <fm-menu-link class="flex flex-1 h-9 !z-[950]" />
        </div>
    }
</div>
